// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

/**
 * The plain words of a rich-text value, for somewhere that cannot show markup.
 *
 * A listing description is written in a rich text editor and stored as HTML. Sharetribe
 * escapes the angle brackets on the way in, so what comes back reads ＜div＞ rather than
 * <div> — which is why a tag that would be invisible on the page arrives intact in a meta
 * tag, and from there into the preview card of every link anyone shares.
 *
 * This is for description meta tags and structured data. It is not a sanitiser: use it on
 * text that is going somewhere markup cannot run, never to make untrusted HTML safe.
 *
 * @param {string} text rich text, with escaped or ordinary tags
 * @returns {string} the same words with the markup taken out
 */
export const plainTextFromRichText = text => {
  if (typeof text !== 'string' || text === '') {
    return '';
  }

  const entities = {
    '&nbsp;': ' ',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
  };

  return (
    text
      // Sharetribe's escaping, undone, so the tags below are recognisable as tags.
      .replace(/＜/g, '<')
      .replace(/＞/g, '>')
      // A block that ends is a space between words, or the last word of one paragraph runs
      // into the first of the next.
      .replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/g, m => entities[m])
      .replace(/\s+/g, ' ')
      .trim()
  );
};
